var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import React, { useMemo } from 'react';
import { SCROLL_OFFSET_Y } from '../../../constants/table';
import { StudentDetails } from '../../StudentDetails';
import { checkIfStudentRow } from '../tableConfig';
var useTableRowActions = function (_a) {
    var domain = _a.domain, groupSkills = _a.groupSkills, selectedData = _a.selectedData, setSelectedData = _a.setSelectedData;
    var rowSelectedData = useMemo(function () { return ({
        status: selectedData === null || selectedData === void 0 ? void 0 : selectedData.status,
        studentId: selectedData === null || selectedData === void 0 ? void 0 : selectedData.studentId,
    }); }, [selectedData]);
    var updateRow = React.useCallback(function (row) {
        if (!rowSelectedData.studentId)
            return undefined;
        if (checkIfStudentRow(row.original) &&
            row.original.id === rowSelectedData.studentId) {
            var timeout_1 = setTimeout(function () {
                row.toggleRowExpanded(true);
                if (rowSelectedData.status) {
                    row.setState({ status: rowSelectedData.status });
                }
            }, 0);
            return function () { return clearTimeout(timeout_1); };
        }
        return undefined;
    }, [rowSelectedData]);
    var renderSubRow = React.useCallback(function (row, refElement) {
        var _a;
        if (!groupSkills || !checkIfStudentRow(row.original))
            return null;
        var handleDetailsLoad = function () {
            if (!rowSelectedData || row.original.id !== rowSelectedData.studentId)
                return;
            window.scrollTo({
                top: refElement.getBoundingClientRect().y +
                    window.scrollY -
                    SCROLL_OFFSET_Y,
                behavior: 'smooth',
            });
            setSelectedData(__assign(__assign({}, selectedData), { studentId: undefined, status: undefined }));
        };
        return (_jsx(StudentDetails, { grades: groupSkills.grades, student: row.original, domain: domain, activeStatus: (_a = row.state) === null || _a === void 0 ? void 0 : _a.status, onLoad: handleDetailsLoad }, void 0));
    }, [groupSkills, domain, rowSelectedData, setSelectedData, selectedData]);
    return {
        updateRow: updateRow,
        renderSubRow: renderSubRow,
    };
};
export { useTableRowActions };
